export enum ApplicantInterviewQuestionTypes {
    multipleChoice = 'Multiple Choice',
    opinionScale = 'Opinion Scale',
    openQuestion = 'Open Question',
    yesNo = 'Yes / No',
}
